export const LEGACY_USER_ROLE = {
    ADMIN: 'Admin',
    OWNER: 'Owner',
    MEMBER: 'Member',
    AGENT: 'Agent',
    DEVELOPER: 'Developer',
    SALES: 'Sales',
} as const

export const LEGACY_USER_PERMISSIONS = {
    BUILDER: 'Builder',
    BUILDER_RO: 'BuilderReadOnly',
    CASE_MANAGEMENT: 'CaseManagement',
}

export type LegacyUserRole = typeof LEGACY_USER_ROLE[keyof typeof LEGACY_USER_ROLE]

export type OrganizationPermissionRelation = 'can_manage_users' | 'can_create_workspace'

export type Organization = {
    id: string
    name: string
    createdAt: string
    flags?: Record<string, string | boolean>
    relations: OrganizationPermissionRelation[]
}

export const ORGANIZATION_FLAGS = {
    RUN_V3_WORKFLOWS: 'runV3Workflows',
}

export type OrganizationRole = {
    id: string
    name: string
    organizationId: string
}

export const OWNER_ROLE_NAME = 'owner'

export const USER_STATUSES = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    PENDING: 'PENDING',
}

export type UserStatus = keyof typeof USER_STATUSES

export type UserRef = {
    id: string
    firstName: string
    lastName: string
    email: string
}

export type UserInLegacyOrganization = UserRef & {
    createDate: string
    teamId: string
    roles: string[]
    userStatus: UserStatus
}

export type OrganizationMembershipOverview = UserRef & {
    title?: string
    createdDateTime: string
    role: OrganizationRole
    status: UserStatus
}


export type UserInFgaOrganization = OrganizationMembershipOverview & {
    organization: Organization
}

export type User = UserInLegacyOrganization | UserInFgaOrganization

const legacyUserRoles = Object.values(LEGACY_USER_ROLE) as string[]

export const getLegacyUserRole = (user?: { roles?: readonly string[] } | null): LegacyUserRole => {
    return user?.roles?.find(role => legacyUserRoles.includes(role)) as LegacyUserRole | undefined ?? LEGACY_USER_ROLE.AGENT
}

export const isFgaOrganizationUser = (user?: User | null): user is UserInFgaOrganization => {
    return !!user && 'organization' in user
}

export const isLegacyOrganizationUser = (user?: User | null): user is UserInLegacyOrganization => {
    return !!user && !isFgaOrganizationUser(user)
}
